import { render, staticRenderFns } from "./CreateNewEmployeeDialog.vue?vue&type=template&id=235f695a&scoped=true"
import script from "./CreateNewEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewEmployeeDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateNewEmployeeDialog.vue?vue&type=style&index=0&id=235f695a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f695a",
  null
  
)

export default component.exports